import "./NavBar.css";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

function NavBar({ currentPage,  mode  }) {

    const [menuOpen, setMenuOpen] = useState(false);
const [closing, setClosing] = useState(false);

const toggleMenu = () => {
  if (menuOpen) {
    setClosing(true);
    setTimeout(() => {
      setMenuOpen(false);
      setClosing(false);
    }, 300); 
  } else {
    setMenuOpen(true);
  }
};


  return (
     <nav className={`hero-nav 
  ${mode === "gallery" ? "gallery-nav" : ""} 
  ${mode === "contact" ? "contact-nav" : ""} 
  ${mode === "testimonials" ? "testimonials-nav" : ""}
`}>



  {/* Desktop Links */}
  <div className="hero-links">
    {mode === "gallery" ? (
  <Link to="/" className="hero-nav-link">Home</Link>
) : (
  <Link to="/gallery" className="hero-nav-link">Gallery</Link>
)}

  {mode === "testimonials" ? (
  <Link to="/" className="hero-nav-link">Home</Link>
) : (
  <Link to="/testimonials" className="hero-nav-link">Testimonials</Link>
)}

    {currentPage === "contact" ? (
  <Link to="/" className="hero-nav-link">Home</Link>
) : (
  <Link to="/contact" className="hero-nav-link">Contact Me</Link>
)}

  </div>

  {/* Mobile Hamburger */}
 
<div
  className={`hero-burger 
    ${menuOpen ? "open" : ""} 
    ${mode === "gallery" ? "gallery-burger" : ""}
    ${mode === "contact" ? "contact-burger" : ""}
    ${mode === "testimonials" ? "testimonials-burger" : ""}
  `}
  onClick={toggleMenu}
>
  <span></span>
  <span></span>
  <span></span>
</div>




  {/* Mobile Dropdown */}

{menuOpen && (
  <div
  className={`hero-mobile-menu 
    ${closing ? "menu-closing" : "menu-open"} 
    ${(mode === "contact" || mode === "gallery" || mode === "testimonials") ? "gray-menu" : ""}
  `}
>

  
   {mode === "gallery" ? (
  <Link to="/" onClick={toggleMenu}>Home</Link>
) : (
  <Link to="/gallery" onClick={toggleMenu}>Gallery</Link>
)}

{mode === "testimonials" ? (
  <Link to="/" onClick={toggleMenu}>Home</Link>
) : (
  <Link to="/testimonials" onClick={toggleMenu}>Testimonials</Link>
)}

    {currentPage === "contact" ? (
      <Link to="/" onClick={toggleMenu}>Home</Link>
    ) : (
      <Link to="/contact" onClick={toggleMenu}>Contact Me</Link>
    )}
  </div>
)}



</nav>
  );
}

export default NavBar;
